// extracted by mini-css-extract-plugin
export default {"paytable":"Paytable_paytable__ShyTP","paytableHeader":"Paytable_paytableHeader__eQuSF","paytableContent":"Paytable_paytableContent__1Gae7"};